import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'
import logo from '../../styles/images/logo-xl.svg'
import { Link } from 'react-router-dom'

const MainMenu = props => {
  const items = props.items
  const listItems = items.map((item, i) => (
    <li
      className={classNames({
        'menu-item': true,
        [item.className]: item.className
      })}
      key={i}
    >
      <Link to={item.url} onClick={props.onItemClick}>
        {item.icon ? <Icon name={item.icon} /> : null}
        <span className='text'>{item.text}</span>
      </Link>
    </li>
  ))
  return (
    <div className='lateral-menu'>
      <div className='logo'>
        <img src={logo} alt='Chairbids Logo' />
      </div>
      <ul className='lateral-menu-list'>{listItems}</ul>
    </div>
  )
}

MainMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string,
      icon: PropTypes.string,
      className: PropTypes.string
    })
  ),
  onItemClick: PropTypes.func
}

export default MainMenu



// WEBPACK FOOTER //
// ./src/ui/menus/main-menu.js